import "antd/es/popover/style";
import _Popover from "antd/es/popover";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { IconCloseOutlined } from '@osui/icons';
import classNames from 'classnames';
import './index.less';
var clsPrefix = 'osui-popover';

var Popover = function Popover(props, ref) {
  var innerTitle = props.title;

  if (props.showCloseIcon) {
    innerTitle = /*#__PURE__*/React.createElement("div", null, props.title, /*#__PURE__*/React.createElement(IconCloseOutlined, {
      className: "".concat(clsPrefix, "-close-icon"),
      // eslint-disable-next-line react/jsx-no-bind
      onClick: function onClick() {
        return props.onVisibleChange && props.onVisibleChange(false);
      }
    }));
  }

  return /*#__PURE__*/React.createElement(_Popover, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    overlayClassName: classNames(clsPrefix, props.overlayClassName),
    title: innerTitle
  }));
};

export default /*#__PURE__*/React.forwardRef(Popover);
//# sourceMappingURL=index.js.map